var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.29274H7.33333M7.33333 8.29274C7.33333 9.58141 8.378 10.6261 9.66667 10.6261C10.9553 10.6261 12 9.58141 12 8.29274C12 7.00408 10.9553 5.95941 9.66667 5.95941C8.378 5.95941 7.33333 7.00408 7.33333 8.29274ZM5 16.0705H9.66667M16.6667 16.0705H19M16.6667 16.0705C16.6667 17.3592 15.622 18.4039 14.3333 18.4039C13.0447 18.4039 12 17.3592 12 16.0705C12 14.7819 13.0447 13.7372 14.3333 13.7372C15.622 13.7372 16.6667 14.7819 16.6667 16.0705ZM14.3333 8.29274H19",
    stroke: "#B4BBCA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.e350d12ce2dbef18c72a7e9b54fc76f0.svg";
export { ForwardRef as ReactComponent };